import React from 'react'
import TypeIt from "typeit-react";
import academy from "../assets/illustration/joel-watch.jpg"

const Academy = () => {
  return (
    <main>
      <section className='academy-intro'>
        <TypeIt
          as={"h1"}
          options={{
            cursor: false,
            speed: 50,
            waitUntilVisible: true,
          }}
        >
          Une initiative qui façonne l'avenir pas à pas.
        </TypeIt>
      </section>
      <div className="separator w-full max-w-6xl mx-auto mb-[150px] px-4">
        <hr className="border-t-2 border-[#e0e0e0] opacity-75" />
      </div>
      <section className='academy-desc bg-neutral-900 p-4 rounded-lg'>
        <div className='academy-title'>
          <h2>Révéler le <span className='text-[#be185d]'>potentiel</span> au monde entier</h2>
          <img src={academy}/>
          <div>
            <p>Le projet "BMS Academy" a vu le jour au moment où Crepe Salée à rejoint notre roster. 
            <br/>
            Dès lors, notre regard n'a jamais cessé d'être tourné vers <b>l'avenir</b> avec l'objectif de mettre en lumière <b>les talents d'aujourd'hui</b></p>
        </div>
        </div>
      </section>
    </main>
  )
}

export default Academy;
